/* FlutterBy Ranch — theme.js
   Progressive enhancement ONLY. Every feature degrades to a fully usable,
   fully visible page with JS off. All motion is prefers-reduced-motion guarded. */
(function () {
  "use strict";
  var root = document.documentElement;
  root.classList.add("js");
  var RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var FINE = window.matchMedia && window.matchMedia("(pointer: fine)").matches;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---- 1. Reveal on scroll (base-visible; .rv hidden only because html.js) ---- */
    (function () {
      var els = [].slice.call(document.querySelectorAll(".rv"));
      if (!els.length) return;
      if (RM || !("IntersectionObserver" in window)) {
        els.forEach(function (el) { el.classList.add("in"); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
      els.forEach(function (el) { io.observe(el); });
      // safety net: anything still hidden after load gets revealed
      window.addEventListener("load", function () {
        setTimeout(function () {
          els.forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in");
          });
        }, 400);
      });
    })();

    /* ---- 2. Count-up numbers ---- */
    (function () {
      var nums = [].slice.call(document.querySelectorAll("[data-countup]"));
      if (!nums.length) return;
      function run(el) {
        var to = parseFloat(el.getAttribute("data-countup")) || 0;
        var suffix = el.getAttribute("data-suffix") || "";
        if (RM) { el.textContent = to + suffix; return; }
        var start = null, dur = 1500;
        function step(t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(eased * to) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (!("IntersectionObserver" in window)) { nums.forEach(run); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      nums.forEach(function (el) { io.observe(el); });
    })();

    /* ---- 3. Mobile nav toggle ---- */
    (function () {
      var btn = document.querySelector("[data-nav-toggle]");
      var sheet = document.querySelector("[data-nav-sheet]");
      if (!btn || !sheet) return;
      function set(open) {
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        sheet.classList.toggle("is-open", open);
        document.body.style.overflow = open ? "hidden" : "";
      }
      btn.addEventListener("click", function () {
        set(btn.getAttribute("aria-expanded") !== "true");
      });
      sheet.addEventListener("click", function (e) {
        if (e.target.closest("a")) set(false);
      });
      window.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
    })();

    /* ---- 4. Sticky header state ---- */
    (function () {
      var hdr = document.querySelector("[data-header]");
      if (!hdr) return;
      var on = function () { hdr.classList.toggle("is-scrolled", window.scrollY > 40); };
      on();
      window.addEventListener("scroll", on, { passive: true });
    })();

    /* ---- 5. Magnetic CTAs (fine pointers only) ---- */
    (function () {
      if (RM || !FINE) return;
      [].slice.call(document.querySelectorAll("[data-magnetic]")).forEach(function (el) {
        el.addEventListener("pointermove", function (e) {
          var r = el.getBoundingClientRect();
          var x = (e.clientX - r.left - r.width / 2) * 0.25;
          var y = (e.clientY - r.top - r.height / 2) * 0.35;
          el.style.transform = "translate(" + x.toFixed(1) + "px," + y.toFixed(1) + "px)";
        });
        el.addEventListener("pointerleave", function () { el.style.transform = ""; });
      });
    })();

    /* ---- 6. Horizontal rail progress bars ---- */
    (function () {
      [].slice.call(document.querySelectorAll("[data-rail]")).forEach(function (rail) {
        var bar = rail.parentNode.querySelector("[data-rail-bar]");
        if (!bar) return;
        var on = function () {
          var max = rail.scrollWidth - rail.clientWidth;
          var p = max > 0 ? rail.scrollLeft / max : 0;
          bar.style.transform = "scaleX(" + (0.1 + p * 0.9).toFixed(3) + ")";
        };
        on();
        rail.addEventListener("scroll", on, { passive: true });
      });
    })();

    /* ---- 7. Contact dual-path toggle ---- */
    (function () {
      var group = document.querySelector("[data-pathgroup]");
      if (!group) return;
      var btns = [].slice.call(group.querySelectorAll("[data-path]"));
      var targets = [].slice.call(document.querySelectorAll("[data-path-text]"));
      function apply(path) {
        btns.forEach(function (b) {
          var active = b.getAttribute("data-path") === path;
          b.setAttribute("aria-pressed", active ? "true" : "false");
        });
        targets.forEach(function (t) {
          var v = t.getAttribute("data-" + path);
          if (v !== null) t.textContent = v;
        });
        var form = document.querySelector("[data-path-form]");
        if (form) form.setAttribute("data-active-path", path);
      }
      btns.forEach(function (b) {
        b.addEventListener("click", function () { apply(b.getAttribute("data-path")); });
      });
      apply("institution");
    })();

    /* ---- 8. Gallery lightbox ---- */
    (function () {
      var triggers = [].slice.call(document.querySelectorAll("[data-lightbox]"));
      if (!triggers.length) return;
      var items = triggers.map(function (t) {
        return { src: t.getAttribute("data-full") || t.getAttribute("data-lightbox"), cap: t.getAttribute("data-cap") || "" };
      });
      var idx = 0;
      var overlay = document.createElement("div");
      overlay.className = "fb-lb";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.innerHTML =
        '<div class="fb-lb__top"><span class="fb-lb__count" data-lb-count></span>' +
        '<button class="fb-lb__close" data-lb-close aria-label="Close">✕ Close</button></div>' +
        '<div class="fb-lb__stage"><button class="fb-lb__nav fb-lb__prev" data-lb-prev aria-label="Previous">‹</button>' +
        '<figure class="fb-lb__fig"><img data-lb-img alt=""><figcaption data-lb-cap></figcaption></figure>' +
        '<button class="fb-lb__nav fb-lb__next" data-lb-next aria-label="Next">›</button></div>';
      document.body.appendChild(overlay);
      var img = overlay.querySelector("[data-lb-img]");
      var cap = overlay.querySelector("[data-lb-cap]");
      var count = overlay.querySelector("[data-lb-count]");
      function render() {
        var it = items[idx];
        img.src = it.src; img.alt = it.cap; cap.textContent = it.cap;
        count.textContent = ("0" + (idx + 1)).slice(-2) + " / " + ("0" + items.length).slice(-2);
      }
      function openLb(i) { idx = i; render(); overlay.classList.add("is-open"); document.body.style.overflow = "hidden"; }
      function closeLb() { overlay.classList.remove("is-open"); document.body.style.overflow = ""; }
      function go(d) { idx = (idx + d + items.length) % items.length; render(); }
      triggers.forEach(function (t, i) {
        t.addEventListener("click", function (e) { e.preventDefault(); openLb(i); });
      });
      overlay.querySelector("[data-lb-close]").addEventListener("click", closeLb);
      overlay.querySelector("[data-lb-prev]").addEventListener("click", function () { go(-1); });
      overlay.querySelector("[data-lb-next]").addEventListener("click", function () { go(1); });
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay || e.target.classList.contains("fb-lb__stage")) closeLb();
      });
      window.addEventListener("keydown", function (e) {
        if (!overlay.classList.contains("is-open")) return;
        if (e.key === "Escape") closeLb();
        if (e.key === "ArrowLeft") go(-1);
        if (e.key === "ArrowRight") go(1);
      });
    })();

    /* ---- 9. Product gallery thumbs + variant/qty ---- */
    (function () {
      var thumbs = [].slice.call(document.querySelectorAll("[data-pdp-thumb]"));
      var main = document.querySelector("[data-pdp-main]");
      if (main && thumbs.length) {
        thumbs.forEach(function (t) {
          t.addEventListener("click", function () {
            main.src = t.getAttribute("data-src");
            thumbs.forEach(function (x) { x.setAttribute("aria-current", "false"); });
            t.setAttribute("aria-current", "true");
          });
        });
      }
      [].slice.call(document.querySelectorAll("[data-qty]")).forEach(function (wrap) {
        var input = wrap.querySelector("input");
        wrap.querySelectorAll("button").forEach(function (b) {
          b.addEventListener("click", function () {
            var v = parseInt(input.value, 10) || 1;
            v += b.getAttribute("data-step") === "up" ? 1 : -1;
            input.value = Math.max(1, v);
          });
        });
      });
    })();
  });
})();
